import { useRecoilValue } from 'recoil';
import { Helmet } from 'react-helmet-async';
import { settingsAtom } from '../../atoms/Settings';

export const AnalyticsHelmet = () => {
  const settings = useRecoilValue(settingsAtom);

  const googleAdsGtmID = settings.settingsV1.google_ads_gtm_id;
  const googleAnalyticsGtmID = settings.settingsV1.google_analytics_gtm_id;
  const gtmID = settings.settingsV1.gtm_id;
  const metaPixelID = settings.settingsV1.meta_pixel_tag;

  const scripts: JSX.Element[] = [];

  // Meta Pixel
  if (metaPixelID) {
    scripts.push(
      <script key='fb-pixel' type='text/javascript'>
        {`
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window,document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${metaPixelID}');
        fbq('track', 'PageView');
        `}
      </script>,
    );
  }

  // Google Ads GTM
  if (googleAdsGtmID) {
    scripts.push(
      <script
        key='ga-gtag-ads'
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${googleAdsGtmID}`}
      />,
      <script key='ga-gtag-ads-config' type='text/javascript'>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${googleAdsGtmID}');
        `}
      </script>,
    );
  }

  // Google Analytics GTM
  if (googleAnalyticsGtmID) {
    scripts.push(
      <script
        key='ga-gtag-analytics'
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsGtmID}`}
      />,
      <script key='ga-gtag-analytics-config' type='text/javascript'>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${googleAnalyticsGtmID}');
        `}
      </script>,
    );
  }

  // GTM Tag
  if (gtmID) {
    scripts.push(
      <script key='gtm-tag' type='text/javascript'>
        {`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmID}');
        `}
      </script>,
    );
  }

  return <Helmet>{scripts}</Helmet>;
};
